(function () {
  'use strict';

  /*
   * YVH Shopify theme asset for preserving Haas Google Ads click identifiers.
   * Add this file to the Git-connected theme and load it with `defer` on every
   * storefront page. Values become order custom attributes after checkout.
   */

  var STORAGE_KEY = 'yvh_haas_google_click_ids_v1';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid'];
  var CONTEXT_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gad_source',
    'gad_campaignid'
  ];
  var currentParams = new URLSearchParams(window.location.search);
  var DEBUG = currentParams.get('haas_oci_debug') === '1';
  var CLEAR_QA = DEBUG && currentParams.get('haas_oci_clear') === '1';
  var syncPromise = null;

  function safeValue(value) {
    if (!value) return '';
    value = String(value).replace(/[\u0000-\u001F\u007F]/g, '').trim();
    return value && value.length <= 500 ? value : '';
  }

  function readState() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      if (!value) return null;
      var parsed = JSON.parse(value);
      if (!parsed || !parsed.captured_at_ms) return null;
      if (Date.now() - parsed.captured_at_ms > MAX_AGE_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function writeState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      /* A current-page cart sync can still succeed without local storage. */
    }
  }

  function captureFromCurrentUrl() {
    var params = new URLSearchParams(window.location.search);
    var hasNewClickId = CLICK_ID_KEYS.some(function (key) {
      return Boolean(safeValue(params.get(key)));
    });

    if (!hasNewClickId) return readState();

    var state = {
      captured_at_ms: Date.now(),
      captured_at: new Date().toISOString(),
      yvh_entry_url: window.location.href.split('#')[0],
      yvh_referrer: document.referrer || '',
      haas_src: safeValue(params.get('haas_src')) || 'johnihaas.com'
    };

    CLICK_ID_KEYS.concat(CONTEXT_KEYS).forEach(function (key) {
      var value = safeValue(params.get(key));
      if (value) state[key] = value;
    });

    writeState(state);
    return state;
  }

  function orderAttributes(state) {
    if (!state) return null;

    /* Empty click-ID values remove stale identifiers from a reused cart. */
    var attributes = {
      haas_gclid: state.gclid || '',
      haas_gbraid: state.gbraid || '',
      haas_wbraid: state.wbraid || '',
      haas_click_captured_at: state.captured_at || '',
      haas_entry_url: (state.yvh_entry_url || '').slice(0, 500),
      haas_referrer: (state.yvh_referrer || '').slice(0, 500),
      haas_source: state.haas_src || 'johnihaas.com'
    };

    CONTEXT_KEYS.forEach(function (key) {
      attributes['haas_' + key] = state[key] || '';
    });

    return attributes;
  }

  function cartEndpoint() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/').replace(/\/$/, '') + '/cart/update.js';
  }

  function clearQaState() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* Continue and clear the server-side cart even if storage is blocked. */
    }

    var attributes = {
      haas_gclid: '',
      haas_gbraid: '',
      haas_wbraid: '',
      haas_click_captured_at: '',
      haas_entry_url: '',
      haas_referrer: '',
      haas_source: ''
    };
    CONTEXT_KEYS.forEach(function (key) {
      attributes['haas_' + key] = '';
    });

    return fetch(cartEndpoint(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('QA cart clear failed: ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        console.info(
          '[Haas OCI QA] test attributes cleared: ' +
          'gclid=' + Boolean(cart.attributes && cart.attributes.haas_gclid) + ', ' +
          'gbraid=' + Boolean(cart.attributes && cart.attributes.haas_gbraid) + ', ' +
          'wbraid=' + Boolean(cart.attributes && cart.attributes.haas_wbraid)
        );
        return cart;
      })
      .catch(function (error) {
        console.warn('[Haas OCI QA] test attribute clear failed', error.message || error);
        return null;
      });
  }

  function syncCart() {
    var state = readState();
    var attributes = orderAttributes(state);
    if (!attributes) return Promise.resolve(null);
    if (syncPromise) return syncPromise;

    syncPromise = fetch(cartEndpoint(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart attribute update failed: ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        if (DEBUG) {
          console.info(
            '[Haas OCI QA] cart attribute sync ok: ' +
            'gclid=' + Boolean(cart.attributes && cart.attributes.haas_gclid) + ', ' +
            'gbraid=' + Boolean(cart.attributes && cart.attributes.haas_gbraid) + ', ' +
            'wbraid=' + Boolean(cart.attributes && cart.attributes.haas_wbraid)
          );
        }
        return cart;
      })
      .catch(function (error) {
        if (DEBUG) console.warn('[Haas OCI QA] cart attribute sync failed', error.message || error);
        return null;
      })
      .finally(function () {
        syncPromise = null;
      });

    return syncPromise;
  }

  if (CLEAR_QA) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', clearQaState, { once: true });
    } else {
      clearQaState();
    }
    return;
  }

  captureFromCurrentUrl();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCart, { once: true });
  } else {
    syncCart();
  }

  document.addEventListener('shopify:cart:lines-update', function () {
    window.setTimeout(syncCart, 0);
  });

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('button[name="add"], [data-add-to-cart], form[action*="/cart/add"] button[type="submit"]')
      : null;
    if (!target) return;
    window.setTimeout(syncCart, 750);
    window.setTimeout(syncCart, 1750);
  }, true);
})();
